import { Chip } from '@mui/material';
import { ChecklistTaskStatus } from '@inversor-hub/types';
import { STATUS_CONFIG } from './checklist-constants';

interface TaskStatusChipProps {
  status: ChecklistTaskStatus;
  size?: 'small' | 'medium';
}

const TaskStatusChip = ({ status, size = 'small' }: TaskStatusChipProps) => {
  const config = STATUS_CONFIG[status];

  return <Chip label={config.label} color={config.color} size={size} />;
};

export default TaskStatusChip;
